<div class="add-language-dialog">
  <div class="add-language-dialog__content">
    <!-- Title -->
    <h2 class="add-language-dialog__title">
      {{ 'settings.global_settings.languages.add_dialog.title' | translateLang }}
    </h2>

    <!-- Language Selector -->
    <div class="add-language-dialog__selector">
      <label class="add-language-dialog__label">
        {{ 'settings.global_settings.languages.add_dialog.label' | translateLang }}
      </label>

      <!-- Search Input -->
      <div class="add-language-dialog__search-wrapper">
        <input
          type="text"
          class="add-language-dialog__search-input"
          [(ngModel)]="searchKeyword"
          (input)="onSearchChange(searchKeyword)"
          [placeholder]="'settings.global_settings.languages.add_dialog.search_placeholder' | translateLang"
          (focus)="onSearchFocus()"
          (click)="onSearchFocus()">

        @if (isSearching) {
          <div class="add-language-dialog__search-spinner">
            <svg class="add-language-dialog__spinner" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="50.265" stroke-dashoffset="12.566" opacity="0.3"/>
            </svg>
          </div>
        }
      </div>

      <div class="add-language-dialog__dropdown-wrapper">
        <div class="add-language-dialog__dropdown-container">
          <app-dropdown
            [items]="availableLanguages"
            [isOpen]="isDropdownOpen"
            [selectedItem]="selectedLanguage"
            (itemSelected)="onLanguageSelected($event)"
            (closed)="onDropdownClosed()">
          </app-dropdown>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="add-language-dialog__footer">
      <button
        class="add-language-dialog__button add-language-dialog__button--cancel"
        (click)="onCancel()">
        {{ 'settings.global_settings.languages.add_dialog.cancel' | translateLang }}
      </button>

      <app-button
        [label]="'settings.global_settings.languages.add_dialog.start_translating' | translateLang"
        variant="yellow"
        [disabled]="!selectedLanguage || isCreating"
        (clicked)="onStartTranslating()">
      </app-button>
    </div>
  </div>
</div>
